<template>
	<add-record
        :title="'Add Purchase Order'"
        :pageInfo="localPageInfo"
        :modalId="'add-purchase-order-modal'"
        :fields="soLineFields"
        :gridId="gridId"
        :onSuggestNameChange="onSuggestNameChange"
        :onSuggestNameSelect="onSuggestNameSelect"
        :getListOfNames="getListOfNames"
        :suggestionList="vendorsList"
        :resetModal="resetModal"
        :saveRecord="savePurchaseOrder"
        :items="itemData"
        :contactsArr="contacts"
        :sortMethod="onGetData"
        :showFilters="showFilters"
        :filterValObj="filterValObj"
        :getDataMethod="onGetData"
        :isCompanyNameDefined="companyName != undefined"
        @addItemClick="onShowModal"
        @updateCheckedRowItemIds="checkedSOLineItemIds = $event"
        isVendor
        class="mr-2">
        <template v-slot:headerSlot>
          <h6>{{ !companyId ? 'Please find your vendor and then select' : ' Select' }} a sales order line from the grid below, or "Add" a new Purchase Order.</h6>
        </template>
	</add-record>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import soLineFields from './fields';
import AddRecord from '@/shared/components/AddRecord';
import { VENDOR_ID, GRID_ID } from '@/shared/constants';

export default {
  name: 'Addpurchaseorder',
  components: {
    AddRecord
  },
  props: {
    companyId: [Number, String],
    companyName: [String],
  },
  data: () => ({
    soLineFields,
    selectedAccount: {},
    filterValObj: {
        id: null,
        companyId: null,
        companyName: null,
        contactId: null
    },
    showFilters: {
        customer: true,
        contact: true
    },
    chosenName:  '',
    checkedSOLineItemIds: [],
    gridId: GRID_ID.PURCHASE_ORDER_ADD_GRID,
    vendorsList: [],
    localPageInfo: {}
  }),
  computed: {
    ...mapGetters('salesOrderLines', {sLineList: 'gridList', sLinePageInfo: 'pageInfo'}),
    // ...mapGetters('salesOrderLines', ['salesOrderLinesByVendor']),
    // ...mapGetters('quoteAdd', ['customers', 'vendors', 'contacts']),
    ...mapGetters('quoteAdd', ['contacts']),
    ...mapGetters('account', ['gridSettingsById']),
    gridSettings() {
      return this.gridSettingsById(this.gridId);
    },
    itemData(){
      return this.sLineList || [];
    }
  },
  methods: {
    // ...mapMutations('salesOrderLines', [ 'setSalesOrderLinesByVendor', 'filterLinesByContactId' ]),
    ...mapMutations('salesOrderLines', [ 'setItem', 'filterLinesByContactId', 'setFilters' ]),
    ...mapActions('companies', ['getByNameAndAccountType']),
    // ...mapActions('salesOrderLines', [ 'getSOLinesByVendorId' ]),
    ...mapActions('salesOrderLines', {getSalesOrderLines: 'getAll', sortGrid: 'sortGrid'}),
    /*...mapActions('quoteAdd', [ 'getContacts', 'clearContacts' ]),*/
    ...mapActions('quoteAdd', [ 'getContacts']),
    ...mapMutations('quoteAdd', {quoteAddSetItem: 'setItem'}),
    ...mapActions('purchaseorders', ['savePurchaseOrderBySalesOrderLineIds']),
    async onSuggestNameSelect(suggestion) {
        this.selectedAccount = suggestion;
        this.filterValObj.id = suggestion.id;
        this.filterValObj.companyId = suggestion.id;
        this.filterValObj.companyName = suggestion.name;
        this.getContacts(suggestion.id);
        await this.onGetData({ ...this.localPageInfo, pageNumber: 1 });
    },
    async onGetData(params) {
      if (this.filterValObj.companyId) {
        const results = await this.getSalesOrderLines({
          ...params,
          filters: {
            vendorId: this.filterValObj.companyId,
            isVendorSource: true
          },
          isSavePageInfo: false,
        });
        this.localPageInfo = { ...this.localPageInfo, ...results.paging };
      }
    },
    async onSuggestNameChange(val) {
        if (val === '') {
            this.resetModal();
        }
    },
    async getListOfNames(name) {
        this.vendorsList = await this.getByNameAndAccountType({
            typeId: VENDOR_ID, name});

        return this.vendorsList;
    },
    async resetModal() {
        if (!this.companyId && !this.companyName) {
            this.filterValObj.id = null;
            this.filterValObj.companyId = null;
            this.filterValObj.companyName = null;
            this.filterValObj.contactId = null;
            /*this.setSalesOrderLinesByVendor([]);*/
            this.setItem({ resource: 'salesOrderLinesByVendor', payload: [] });
            // this.clearContacts();
            this.quoteAddSetItem({ resource: 'contacts', payload: [] });
        }
        this.checkedSOLineItemIds = [];
    },
    async savePurchaseOrder() {
        const purchaseOrder = await this.savePurchaseOrderBySalesOrderLineIds({
          companyId: this.filterValObj.companyId,
          contactId: (this.filterValObj.contactId) ? this.filterValObj.contactId : 0,
          salesOrderLineIds: this.checkedSOLineItemIds
        });

        if (purchaseOrder.id != undefined) {
            this.$snotify.success('Purchase Order has been created', 'Purchase Order');
            this.$router.push({ name: 'purchaseorders.edit', params: { id: purchaseOrder.id } });
        }
    },
    onShowModal() {
      let companyId= parseInt(this.companyId);
      if (this.filterValObj.companyId != companyId) {
        this.onSuggestNameSelect({
          id: companyId,
          name: this.companyName
        });  
      } if (this.filterValObj.companyName != this.companyName) {
        this.filterValObj.companyName = this.companyName;
      } if (this.contacts.length == 0) {
        this.getContacts(companyId);
      } else if (this.itemData.length == 0) {
        this.onGetData({ ...this.localPageInfo,  pageNumber: 1 });
      }
    }
    
  },
  created() {
    this.setItem({ resource:'gridList', payload: [] });
    this.localPageInfo = { ...this.gridSettings.sort, ...this.gridSettings.pageSize };
    // if (this.companyId && this.companyName) {
    //   this.onSuggestNameSelect({
    //     id: parseInt(this.companyId),
    //     name: this.companyName
    //   });
    // }
  }
};
</script>
